import React from "react";
import { MessageCircle } from "lucide-react";

export default function WhatsappFab() {
  return (
    <a
      href="https://wa.me/919845048406?text=Hi%2C%20I%27m%20interested%20in%20your%20wholesale%20flooring%20%26%20carpet%20range."
      target="_blank"
      rel="noreferrer"
      className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-[70] group"
      aria-label="Chat with us on WhatsApp"
      data-testid="whatsapp-fab"
    >
      <span className="absolute inset-0 rounded-full bg-emerald-500/60 blur-xl opacity-70 group-hover:opacity-100 animate-pulse" />
      <span className="relative inline-flex h-14 w-14 items-center justify-center rounded-full bg-emerald-500 hover:bg-emerald-600 text-white shadow-lg shadow-emerald-700/40 transition-all duration-300 group-hover:scale-105">
        <MessageCircle className="h-6 w-6" />
      </span>
    </a>
  );
}
